import toast, { ToastPosition } from 'react-hot-toast';
import { FiInfo } from 'react-icons/fi';
import { v4 as uuid } from 'uuid';

interface IInfoToastProps {
  duration?: number;
  position?: ToastPosition;
  toastMessage: string;
}

export function InfoToast({
  duration = 3000,
  position = 'top-right',
  toastMessage,
}: IInfoToastProps) {
  return toast(toastMessage, {
    id: uuid(),
    icon: <FiInfo className="min-w-fit" size={20} />,
    position,
    duration,
    style: {
      color: '#FFF',
      background: '#656564',
      padding: '.75rem 1.25rem',
    },
  });
}
